export function isValidEmail(value: string): boolean {
    if (!value) return true;
    const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(value);
}

export function isValidWebUrl(value: string): boolean {
    if (!value) return true;
    const regex =
        /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    return regex.test(value);
}

export function isValidPassword(value: string): boolean {
    if (!value) return false;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpecialChar = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/.test(value);
    const isValidLength = value.length >= 8;
    return (
        hasUpperCase &&
        hasLowerCase &&
        hasNumber &&
        hasSpecialChar &&
        isValidLength
    );
}

export function isValidPhone(value: string): boolean {
    if (!value) return true;
    const regex = /^\+?[1-9]\d{7,14}$/;
    return regex.test(value);
}
